/**
 * Type guard function that checks if a value is null or undefined.
 * Returns true if the value is null or undefined, false otherwise.
 *
 * @param value - The value to check
 * @returns True if the value is null or undefined, false otherwise
 *
 * @example
 * ```ts
 * import { NullQ } from "@pdfking/structs"
 *
 * NullQ(null) // true
 * NullQ(undefined) // true
 * NullQ("hello") // false
 *
 * // Use in conditional logic
 * const input: string | undefined = undefined
 * NullQ(input) ? "default" : input // "default"
 * ```
 */
export const NullQ = (value: unknown): value is null | undefined => value == null
